// extracted by css-extract-rspack-plugin
export default {"line":"XLmbRjh1KP8_QKli__line___","horizontal":"piUAb6GgEWY7QCTn__horizontal___","vertical":"tYqv5Yn81SU22Oki__vertical___"};